import styled, { css } from 'styled-components';
import media from '../../../styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';
import { Dialog } from 'primereact/dialog';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

let isMobile = isMobileDevice();

export const UserPanelContainer = styled.div`
    font-family: AvenirNextWorld Regular;
    background: #130e49;
    text-align: ${isMobile ? 'left' : 'right'};
    width: 100%;
    font-size: ${isMobile && '0.875rem'};
    padding: ${isMobile && '10px 0.9rem 20px 0.9rem'};

    ${media.portraitDevice`
        ${({ isSideNavBar }) =>
            isSideNavBar &&
            css`
                padding: 10px 0.9rem 0px 0.9rem;
            `}
    `}

    ${media.mobileDevice`
        margin: 0;
        padding: 10px 0.9rem 10px 0.9rem;
        font-size: 0.875rem;
        display: flex;
        flex-direction: column;
        text-align: left;
        &::-webkit-scrollbar {
        display: none;
    }
    `}
`;

export const HR = styled.hr`
    display: ${isMobile ? 'block' : 'none'};
    width: 97%;
    opacity: 0.36;
    color: #ffffff;
    background-color: #ffffff;
    ${media.portraitDevice`
        display: block;
    `}

    ${media.mobileDevice`
        display: block;
        width: 90%;
        opacity: 0.36;
        color: #ffffff;
    `}
`;
export const DialogContainer = styled(Dialog)`
    background: #ffffff;
    &.p-dialog {
        box-shadow: 0px 0px 6px #00000029 !important;
        /* border: 1px solid #dcdcdc !important; */
        border-radius: 6px !important;
        width: 48vw;
        height: 75vh;
    }
    ${media.mobileDevice`
    &.p-dialog {        
        width:98vw;
        height:90vh;
    }

    &.p-dialog-content {
        border-bottom-right-radius: 6px!important;
        border-bottom-left-radius: 6px!important;
    }
    `}

    ${media.portraitDevice`
        &.p-dialog {
            width: 86vw;
        }

        &.p-dialog-content {
            border-bottom-right-radius: 6px !important;
            border-bottom-left-radius: 6px !important;
        }
    `}
    
    &.p-dialog .p-dialog-header {
        border-bottom: 0 none;
        background: #ffffff;
        color: #140f4b !important;
        padding: 20px 20px 12px 20px !important;
    }
    &.p-dialog .p-dialog-header .p-dialog-header-icon {
        width: 2rem;
        height: 2rem;
        color: #140f4b !important;
        border: 0 none;
        background: transparent;
        margin-right: 0.5rem;
    }
    &.pi {
        font-size: 20px;
    }
    &.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {
        color: #140f4b !important;
        border-color: transparent !important;
        background: #ffffff !important;
    }

    &.p-dialog .p-dialog-header .p-dialog-header-icon:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #ffffff;
    }
    &.p-dialog .p-dialog-content {
        border-bottom-right-radius: 6px !important;
        border-bottom-left-radius: 6px !important;
        margin-right: 2px;
        ${scrollBarStyle}
    }
`;
export const LabelDemiStyle = styled.div`
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 14px;
    text-align: left;
    margin-top: ${(props) => (props.topMargin ? props.topMargin : '0px')};
`;
export const LabelRegularStyle = styled.div`
    font-family: AvenirNextWorld Regular;
    color: #202124;
    font-size: 16px;
    text-align: left;
    word-break: ${(props) => (props.breakWord ? 'break-word' : 'normal')};
`;
